import { usePermissionsContext } from '@/contexts/PermissionsContext'

/**
 * Hook to check user permissions from Auth0 token claims.
 * Backed by PermissionsProvider, which decodes the token once app-wide.
 */
export const usePermissions = usePermissionsContext
